import { GeneralStyle } from '@website-builder/model/style/general-style';

export class DescriptionListStyle extends GeneralStyle {
  marker = 'uk-list-disc';
  markerColor = 'uk-list-primary';
  listStyle = 'uk-list-divider';
  size = '';
  layout = '';

  static normalize(styles: Partial<DescriptionListStyle>): DescriptionListStyle {
    const generalStyle = GeneralStyle.normalize(styles);
    const pureStyles = new DescriptionListStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.marker = styles.marker ?? pureStyles.marker;
    pureStyles.markerColor = styles.markerColor ?? pureStyles.markerColor;
    pureStyles.listStyle = styles.listStyle ?? pureStyles.listStyle;
    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.layout = styles.layout ?? pureStyles.layout;

    return pureStyles;
  }
}
